module.exports = __webpack_public_path__ + "img/03_no.b6fd7ad2.svg";